module.exports = __webpack_public_path__ + "img/Gina.7b6fb47b.svg";